angular.module 'zc.commonApi'

.factory 'Project', ($resource, $q, $state, Api, projectServiceResponseTransformer, projectServiceRequestTransformer) ->
  URL = "/api/projects/:projectId"
  Project = $resource Api.path(URL),
    get:
      projectId: '@id'
      transformResponse: projectServiceResponseTransformer,
  ,
    query:
      method: 'GET'
      transformResponse: projectServiceResponseTransformer
      isArray: false # Rails returns object instead of array
      cache: true
    update:
      method: 'PATCH'
      transformRequest: projectServiceRequestTransformer
      transformResponse: projectServiceResponseTransformer
    'delete':
      method: 'DELETE'
    removePageTypes:
      method: 'DELETE'
      url: Api.path("#{URL}/remove_page_types/:page_type")
    visitorIdsForDM:
      method: 'GET'
      url: Api.path("#{URL}/visitor_ids_for_dm")
    uploadVisitorIdsForDM:
      method: 'PATCH'
      url: Api.path("#{URL}/upload_visitor_ids_for_dm")
      headers:
        'Content-Type': undefined
      transformRequest: (data) ->
        formData = new FormData()
        angular.forEach data, (val, key) ->
          formData.append key, val
        formData
    uploadPageTypes:
      method: 'PATCH'
      url: Api.path("#{URL}/upload_page_types/:page_type")
      headers:
        'Content-Type': undefined
      transformRequest: (data) ->
        formData = new FormData()
        angular.forEach data, (val, key) ->
          formData.append key, val
        formData


  doGet = (selector, params) ->
    $q (resolve, reject) ->
      Project.get(angular.extend(selector, params)).$promise.then (res) ->
        if res.project
          response = projectServiceResponseTransformer(res)
          resolve response.project
        else
          # Rails returns success callback even when project is not found
          reject()
      , (err) ->
        reject err

  service =
    currentProject: null

    create: (params) ->
      $q (resolve, reject) ->
        Project.save({project: params}).$promise.then (res) ->
          resolve res.project

    update: (params, update) ->
      $q (resolve, reject) ->
        Project.update(params, update).$promise.then (res) ->
          if !res.success
            reject {}
          else
            resolve res.project

    removePageTypes: (params) ->
      Project.removePageTypes(params).$promise

    remove: (params) ->
      Project.delete(params).$promise

    all: ->
      Project.query().$promise.then (res) ->
        service.projects = res.projects
        res.projects

    get: (projectId, params={}) ->
      doGet({projectId}, params)

    getByApikey: (apikey, params={}) ->
      doGet({projectId: "apikey:#{apikey}"}, params)

    getVisitorIdsForDM: (params) ->
      $q (resolve, reject) ->
        Project.visitorIdsForDM(params).$promise.then (res) ->
          resolve res.visitor_ids_for_dm

    uploadVisitorIdsForDM: (params, update) ->
      $q (resolve, reject) ->
        Project.uploadVisitorIdsForDM(params, update)
        .$promise
        .then (res) ->
          resolve res.visitor_ids_for_dm

    uploadPageTypes: (params, update) ->
      $q (resolve, reject) ->
        Project.uploadPageTypes(params, update)
        .$promise
        .then (res) ->
          resolve res.page_types

    getCurrent: (projectId) ->
      $q (resolve, reject) ->

        if projectId
          service.get(projectId).then (project) ->
            service.currentProject = project
            resolve project
        else
          service.currentProject = null
          resolve null

    goHome: (project) ->
      service.currentProject = project
      $state.go 'admin.projects.campaigns.list',
        projectId: project.id

    getRegion: ->
      service.currentProject?.region

    isZenClerk: ->
      service.currentProject?.product_line is 'zenclerk'

    isZenClerkS: ->
      service.currentProject?.product_line is 'zenclerk_s'

    isZenClerkLP: ->
      service.currentProject?.product_line is 'zenclerk_lp'

  service



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/project_service.js.coffee